import {
  AuthProvider, HttpError, UserIdentity, fetchUtils,
} from 'react-admin';

import { getAuthHeader, getClerkClient, signOut } from './auth';

export const authProvider: AuthProvider = {
  async login() {
    throw new Error('login not implemented');
  },
  async logout() {
    console.log('Logging out user');
    await signOut();
  },
  async checkError(e) {
    console.error('Auth error:', e);
    if (e.status === 401 || e.status === 403) {
      return await Promise.reject(e);
    }
    return await Promise.resolve();
  },
  async checkAuth(): Promise<void> {
    const session = (await getClerkClient())?.session;
    console.log('Checking auth, session:', session);
    return session ? await Promise.resolve() : await Promise.reject(new HttpError('No Session Found', 401));
  },
  async getPermissions() {
    try {
      const response = await authHttpClient('/api/auth/permissions');

      return response.json as string[];
    } catch {
      return undefined;
    }
  },
  async getIdentity(): Promise<UserIdentity> {
    const user = (await getClerkClient())?.user;
    console.log('Getting identity, user:', user);
    if (!user) throw new HttpError('No user found', 401);
    return {
      id: user.id,
      fullName: user.fullName ?? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
      avatar: user.imageUrl,
    };
  },
};

export async function authHttpClient(
  url: string,
  options: fetchUtils.Options = {},
): Promise<{ status: number; headers: Headers; body: string; json: any; }> {
  const headers = new Headers({ Accept: 'application/json' });

  if (!options.headers) {
    options.headers = headers;
  }

  headers.set('X-App', 'studio-manager-admin');

  try {
    const authHeader = await getAuthHeader();
    if (authHeader) {
      headers.set('Authorization', authHeader);
    }
  } catch (error) {
    throw new HttpError('No auth header available', 401);
  }

  return await fetchUtils.fetchJson(url, options);
}
